/**
 * Обрезает изображение до квадрата по центру
 * @param file - Файл изображения
 * @param outputFormat - Формат выходного изображения ('image/jpeg' или 'image/png')
 * @param quality - Качество для JPEG (0-1), игнорируется для PNG
 * @returns Promise<Blob> - Обрезанное изображение как Blob
 */
export async function cropImageToSquare(
  file: File | Blob,
  outputFormat: 'image/jpeg' | 'image/png' = 'image/jpeg',
  quality: number = 0.92
): Promise<Blob> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(file);

    img.onload = () => {
      URL.revokeObjectURL(url);

      // Определяем размер квадрата (минимальная сторона)
      const size = Math.min(img.width, img.height);

      // Вычисляем координаты для обрезки по центру
      const x = (img.width - size) / 2;
      const y = (img.height - size) / 2;

      // Создаем canvas для обрезки
      const canvas = document.createElement('canvas');
      canvas.width = size;
      canvas.height = size;
      const ctx = canvas.getContext('2d');

      if (!ctx) {
        reject(new Error('Failed to get canvas context'));
        return;
      }

      // Рисуем обрезанное изображение
      ctx.drawImage(img, x, y, size, size, 0, 0, size, size);

      // Конвертируем в Blob
      canvas.toBlob(
        (blob) => {
          if (!blob) {
            reject(new Error('Failed to create blob from canvas'));
            return;
          }
          resolve(blob);
        },
        outputFormat,
        quality
      );
    };

    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('Failed to load image'));
    };

    img.src = url;
  });
}
